export function formatDate(dateString, format = 'long') {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: format,
        day: 'numeric'
    });
}
